module.exports = __webpack_public_path__ + "static/media/ck.bd3a061c.svg";